import React, { useState } from "react";
import {
  subscribeForm, subscribeInputMail, emailInput,
  subscribeInputText, subscribeInputForm, subtitle, nameInput,
  termsAndConditions, termsCheckbox, submitBtn, errorMessage,
  inputChecked, successMsg, box, text
} from "./style.mod.scss";
import locale from "locales";
import { loadRecaptcha } from "helpers/load-recaptcha";
import { Formik, Field, Form } from "formik";
import useNewsletterSubscribe from "../../hooks/useNewsletterSubscribe";
import TickIcon from "assets/svgs/tick.svg";

const ActiveSubscribeForm = ({ data }) => {
  const id = data?.id;
  const redirectAtPage = data?.redirectToThisPage;

  const { submitted, email, error, handleSubscribe, onEmailChange } = useNewsletterSubscribe(id, redirectAtPage);
  const [termsChecked, setTermsChecked] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);

  const handleTermsClick = () => {
    setTermsChecked(!termsChecked);
  };

  const handlePrivacyClick = () => {
    setPrivacyChecked(!privacyChecked);
  };

  return (
    <div className={subscribeForm} id="activeSubscribeForm" style={{ backgroundColor: data.bgColor && data.bgColor.hex }}>
      <Formik initialValues={{ email: "" }} onSubmit={handleSubscribe}>
        <Form className={subscribeInputForm}>
          {!submitted && (
            <>
              <div className={subscribeInputMail}>
                <Field required className={nameInput} onChange={(e) => onEmailChange(e)} onFocus={loadRecaptcha} name="name" placeholder={locale.footer.firstName} />
                <Field required className={emailInput} onFocus={loadRecaptcha} onChange={(e) => onEmailChange(e)} value={email} name="email" placeholder={locale.footer.emailAddress} />
                {error && <p className={errorMessage}>{error}</p>}
                {!data?.disablePrivacyAndPolicy &&
                  <a target="_BLANK" rel="noreferrer" className={termsAndConditions} href={locale?.footer?.termsConditionsLink}>
                    {locale.footer.termsConditions}
                  </a>}
                {data?.options?.map((item, i) => {

                  const [optionCheck, setOptionsChecked] = useState(false);

                  const handleOptionsClick = () => {
                    setOptionsChecked(!optionCheck);
                  };

                  return (
                    <label className={termsCheckbox} key={i}>
                      <input
                        type="checkbox"
                        name="checked"
                        value="terms"
                        id={item}
                        checked={optionCheck}
                        onChange={handleOptionsClick}
                        className={optionCheck && inputChecked}
                      />
                      <span>
                        {item}
                      </span>
                    </label>
                  );
                })}
                {data?.options?.length == 0 &&
                  <>
                    <label className={termsCheckbox}>
                      <input
                        type="checkbox"
                        name="checked"
                        value="terms"
                        id="termsCheckbox"
                        checked={termsChecked}
                        onChange={handleTermsClick}
                        className={termsChecked && inputChecked}
                      />
                      <span>
                        {locale.footer.iAccepptTermsAndConditions}
                      </span>
                    </label>
                    <label className={termsCheckbox}>
                      <input
                        type="checkbox"
                        name="checked"
                        value="privacy"
                        id="privacyCheckbox"
                        checked={privacyChecked}
                        onChange={handlePrivacyClick}
                        className={privacyChecked && inputChecked}
                      />
                      <span>
                        {locale.footer.privacyAndPolicy}
                      </span>
                    </label>
                  </>}
                <button type="submit" style={{ backgroundColor: data?.btnColor && data?.btnColor?.hex }} id="submitForm" className={submitBtn}>
                  {data?.buttonText ? data?.buttonText : locale.footer.winNow}
                </button>
              </div>
              <div className={subscribeInputText}>
                <p style={{ color: data?.textColor && data?.textColor?.hex }} className={subtitle}>{data?.description}</p>
              </div>
            </>
          )}
          {submitted && !redirectAtPage && <div className={successMsg}>
            <div className={box}>
              <TickIcon />
              <div className={text}>
                <p>{data?.sucessSubmissionTitle ? data?.sucessSubmissionTitle : locale.footer.thankYouTitle}</p>
                <p>{data?.successSubmissionDescription ? data?.successSubmissionDescription : locale.footer.thankYouBody}</p>
              </div>
            </div>
          </div>}
        </Form>
      </Formik>
    </div>
  );
};

export default ActiveSubscribeForm;
